module.exports = __webpack_public_path__ + "static/media/freddy-amill.7efcda52.md";